<template>
  <div>
    <div class="bottom">
      <div class="mian_box">
        <div class="left">
          <div class="logo">
            <img src="../../assets/img/logo.png" alt="" />
            <div class="logo_title">建造云</div>
          </div>
          <div class="phone">
            <div><i class="el-icon-phone"></i>025-52391861</div>
            <div><img src="../../assets/img/u24.png" alt="" />https://www.seuicc.com</div>
          </div>
        </div>
        <div class="center">
          <div>快速访问</div>
          <div class="fastAccess">
            <router-link to="/">首页</router-link>
            <router-link to="/newsInformation">新闻资讯</router-link>
            <router-link to="/case_25_bridge_list">应用场景</router-link>
            <router-link to="/partnership">合作关系</router-link>
            <router-link to="/case_32_algurithm_list">核心技术</router-link>
            <router-link to="/selfService">自助服务</router-link>
            <router-link to="/case_33_team_list">科研资源</router-link>
            <router-link to="/popular">科普工作</router-link>
          </div>
          <div style="margin-left: -100px;" class="fix"><a class="fix" href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer"><span>苏ICP备19021824号-4</span></a> | © Copyright 东南大学版权所有</div>
        </div>
        <div class="right">
          <div>建造云</div>
          <router-link to="/"><img src="../../assets/img/u35.png" alt="" /></router-link>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.bottom {
  background-color: rgba(46, 48, 51);
  height: 230px;
  padding: 40px 0;
  .mian_box {
    width: 1000px;
    margin: 0 auto;
    padding: 0 100px;
    color: #ffffff;
    display: flex;
    justify-content: space-between;
    .left {
      .logo {
        display: flex;
        img {
          width: 70px;
          height: 70px;
        }
        .logo_title {
          font-weight: 100;
          font-size: 28px;
          margin: 13px 0 0 20px;
        }
      }
      .phone {
        color: white;
        font-size: 12px;
        i {
          margin: 20px 5px 20px 0;
        }
        img {
          width: 13px;
          height: 13px;
          vertical-align: middle;
          margin-right: 5px;
        }
      }
    }
    .center {
      width: 300px;
      margin-left: 50px;
      .fastAccess {
        display: flex;
        flex-wrap: wrap;
        margin-top: 55px;
        a {
          width: 70px;
          margin-right: 80px;
          margin-bottom: 10px;
          text-decoration: underline;
          color: #ffffff;
          font-size: 14px;
          cursor: pointer;
        }
      }
      .fix {
        font-weight: 400;
        font-style: normal;
        color: #7f7f7f;
        font-size: 14px;
        margin-top: 27px;
      }
    }
    .right {
      text-align: center;
      img {
        width: 141px;
        height: 141px;
        margin-top: 30px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/bottom.vue